module.exports = require("npm:@eika-dagligbank/sdc-mobilbank-lib@3.8.0/dist/index.js");